export default {"src":"/_next/static/media/vogue-logo.a9ef9d69.svg","height":34,"width":130,"blurWidth":0,"blurHeight":0};